import styled from 'styled-components';

const Wrap = styled.div`
  &.partner-logos {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    align-items: center;
    justify-items: center;
    gap: 32px 24px;
    padding: 0 16px 32px;
    width: 100%;
    box-sizing: border-box;
  }

  .partner-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-width: 0;
    min-height: 61px;
  }

  .partner-logo img {
    display: block;
    width: 100%;
    max-width: 150px;
    height: 61px;
    object-fit: contain;
  }

  /* Tablets */
  @media (max-width: 992px) {
    &.partner-logos {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 28px 20px;
    }
  }

  /* Mobile */
  @media (max-width: 576px) {
    &.partner-logos {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 24px 16px;
      padding: 0 8px 24px;
    }

    .partner-logo {
      min-height: 48px;
    }

    .partner-logo img {
      max-width: 130px;
      height: 48px;
    }
  }

  /* Very small screens */
  @media (max-width: 360px) {
    &.partner-logos {
      gap: 20px 10px;
      padding-right: 0;
      padding-left: 0;
    }

    .partner-logo img {
      max-width: 115px;
      height: 42px;
    }
  }
`;

export default { Wrap };
